import { Typography } from '@/components/typography/typography'
import { PromotionCodeBanner } from '@/features/promotion-code'
import { cn } from '@/libs/tw'
import { jsonResponsiveImageSchemaType } from '@/types/jsonResponsiveImage.type'

import { ContentContainer } from './contentContainer'

type HeroProps = {
	image: jsonResponsiveImageSchemaType
	title?: string | null
}

export const Hero = ({ image, title }: HeroProps) => {
	return (
		<section className={cn('md:py-auto relative w-full bg-naturel py-40 md:h-[400px]')}>
			<img
				className={cn('hidden h-full w-full object-cover md:block')}
				src={image.src}
				alt={image.alt}
			/>

			<div className={cn('flex h-full w-full justify-center md:absolute md:left-0 md:top-0')}>
				<ContentContainer>
					<div
						className={cn(
							'flex h-full w-full flex-col justify-center gap-24 text-naturel'
						)}
					>
						<Typography
							element="h1"
							style="h1"
							className="text-heroTitle md:text-naturel"
						>
							{title}
						</Typography>
						<PromotionCodeBanner />
					</div>
				</ContentContainer>
			</div>
		</section>
	)
}
